// HtmlRenderer.tsx
import React from 'react';
import './render_html.css';
import { Box, useTheme } from '@mui/material';
import { colors } from '../../constants/colors';


interface HtmlRendererProps {
    html: string;
    className?: string;
    maxLines?: number; // ✅ เพิ่มจำนวนบรรทัดสูงสุด
    ellipsis?: string; // ✅ เพิ่มข้อความท้าย
}

const HtmlRenderer: React.FC<HtmlRendererProps> = ({
    html,
    className,
    maxLines,
    ellipsis = '...', // ค่า default
}) => {
    const theme = useTheme();
    const mode = theme.palette.mode
    // const { mode } = useColorScheme();
    // const fontSize = useSelector((state: RootState) => state.fontSize.value);
    const stripHtmlTags = (html: string) => {
        return html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
    };
    const processedHtml = html.replace(/\n/g, '<br />');

    return (
        <Box
            component="div"
            sx={{
                // p: {
                // fontSize: `${16 * fontSize}px`, // 👈 เพิ่มตรงนี้
                // },
                overflowX: 'auto !important',
                'table': {
                    tableLayout: 'auto',
                    color: mode === 'dark' ? 'white' : undefined,
                    backgroundColor: mode === 'dark' ? 'black !important' : undefined,
                    minWidth: '800px',
                },
                'th, td': {
                    border: '1px solid #ccc',
                    padding: '8px',
                    verticalAlign: 'top',
                    whiteSpace: 'break-spaces !important',
                },
                'th:first-of-type, td:first-of-type': {
                    minWidth: '150px',
                    whiteSpace: 'nowrap',
                },
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                ...(maxLines && {
                    WebkitLineClamp: maxLines,
                }),
            }}
            className={`ck-content${className ? ` ${className}` : ''}`}
            style={{
                color: mode === 'dark' ? 'white' : colors.textNormal,
                backgroundColor: mode === 'dark' ? 'black' : 'white',
            }}
            title={maxLines ? stripHtmlTags(html) : undefined}
            // title={ellipsis ? html : undefined}
            dangerouslySetInnerHTML={{ __html: processedHtml }}
        />
    );
};

export default HtmlRenderer;
